import { graphql } from '@/gql/graphql';

const ChatPreferenceOptimisticFragment = graphql(/* GraphQL */ `
  fragment ChatPreferenceOptimistic on chat {
    id
    is_hidden
  }
`);

type OptimisticChatPreference = {
  __typename: 'chat';
  id: string;
  is_hidden?: boolean;
};

export type ChatPreferenceOptimisticCache = {
  writeFragment: (
    fragment: typeof ChatPreferenceOptimisticFragment,
    data: {
      __typename: 'chat';
      id: string;
      is_hidden: boolean;
    },
  ) => unknown;
};

export default function insert_chat_person_preference_one(
  args: {
    object: ReturnType<
      typeof graphql.scalar<'chat_person_preference_insert_input'>
    >;
  },
  cache: ChatPreferenceOptimisticCache,
) {
  const {
    chat_id: chatId,
    is_hidden: isHidden,
    notification_preference: notificationPreference,
    person_id: personId,
  } = args.object;

  if (
    chatId === null ||
    chatId === undefined ||
    personId === null ||
    personId === undefined ||
    ((isHidden === null || isHidden === undefined) &&
      notificationPreference === undefined)
  ) {
    return null;
  }

  const chat: OptimisticChatPreference = {
    __typename: 'chat',
    id: chatId,
  };

  if (isHidden !== null && isHidden !== undefined) {
    chat.is_hidden = isHidden;
    cache.writeFragment(ChatPreferenceOptimisticFragment, {
      __typename: 'chat',
      id: chatId,
      is_hidden: isHidden,
    });
  }
  return {
    __typename: 'chat_person_preference',
    chat_id: chatId,
    person_id: personId,
    ...(notificationPreference === undefined
      ? {}
      : { notification_preference: notificationPreference }),
    chat,
  };
}
